import Axios from '../lib/axios'
import store from '@/store'

class TherapyDrugsService {
  async index () {
    const result = await Axios.authenticated().get(`/therapyDrugs/${patientId}`, {})
    return result
  }
  async current () {
    const result = await Axios.authenticated().get(`/therapyDrugs/${patientId}/current`, {})
    return result
  }
  async notInUse () {
    const result = await Axios.authenticated().get(`/therapyDrugs/${patientId}/notInUse`, {})
    return result
  }
  async delete (patientId, therapyDrugId) {
    const result = await Axios.authenticated().delete(`/therapyDrugs/${patientId}/delete/${therapyDrugId}`)
    return result
  }

  async createtOrUpdate (patientId, therapyDrugsData) {
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total)
    }
    const result = await Axios.authenticated().post(`/therapyDrugs/${patientId}`, therapyDrugsData, config)
    return result
  }
}
export default new TherapyDrugsService()
